import { Map, List } from "immutable";
import { STATE_STATUS } from "constants";
import {ONBOARDING_ACTIONS} from 'constants/actions';
import { OnboardingCasesListPipeline } from "utilities";
import { OnboardingCasesRecord } from "../../records";

const INITIAL_STATE = new Map({
    status : STATE_STATUS.UNFETCHED,
    caseList : List(),
    count : null,
    deleteDocumentState : STATE_STATUS.UNFETCHED,
    caseDetails: Map({
        status : STATE_STATUS.UNFETCHED,
        data: new OnboardingCasesRecord()
    }),
    pendency : Map({
        status : STATE_STATUS.UNFETCHED,
        data : List()
    }),
    companyBackground: Map({
        status : STATE_STATUS.UNFETCHED,
        data: []
    }),
    deviationMatrixReview: Map({
        status : STATE_STATUS.UNFETCHED,
        data: []
    }),
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch (type) {
        case ONBOARDING_ACTIONS.FETCH_CASES_LIST:
            return state.set("status" , STATE_STATUS.FETCHING);

        case ONBOARDING_ACTIONS.FETCHED_CASES_LIST : 
            return state
                .set("status" , STATE_STATUS.FETCHED)
                .set('count' , payload.data['count'])
                .set("casesList" , OnboardingCasesListPipeline.run(List(payload.data['results'])));

        case ONBOARDING_ACTIONS.FAILED_FETCH_CASES_LIST:
            return state.set("status", STATE_STATUS.FETCH_FAILED);
        

        case ONBOARDING_ACTIONS.CLEAR_WORKFLOW_CASE_DETAIL:
                return state.setIn(["caseDetails","status"] , STATE_STATUS.UNFETCHED)
                .setIn(["caseDetails", "data"], new OnboardingCasesRecord())
    
        case ONBOARDING_ACTIONS.FETCH_WORKFLOW_CASE_DETAIL:
            return state.setIn(["caseDetails","status"] , STATE_STATUS.FETCHING);

        case ONBOARDING_ACTIONS.FETCHED_WORKFLOW_CASE_DETAIL : 
            return state
                .setIn(["caseDetails","status"] , STATE_STATUS.FETCHED)
                .setIn(["caseDetails", "data"] , new OnboardingCasesRecord(payload.data['results'][0]));

        case ONBOARDING_ACTIONS.FAILED_FETCH_CASE_DETAIL:
            return state.setIn(["caseDetails", "status"] , STATE_STATUS.FETCH_FAILED);

        case ONBOARDING_ACTIONS.FETCH_CASE_PENDENCY_DETAIL:
            return state.setIn(["pendency", "status"] , STATE_STATUS.FETCHING);

        case ONBOARDING_ACTIONS.FETCHED_CASE_PENDENCY_DETAIL : 
            return state
                .setIn(["pendency","status"] , STATE_STATUS.FETCHED)
                .setIn(["pendency", "data"] , List(payload.data.pending_items));

        case ONBOARDING_ACTIONS.FAILED_FETCH_CASE_PENDENCY_DETAIL:
            return state.setIn(["pendency", "status"] , STATE_STATUS.FETCH_FAILED);
        
        case ONBOARDING_ACTIONS.FETCH_COMPANY_BACKGROUND:
            return state.setIn(["companyBackground","status"] , STATE_STATUS.FETCHING);

        case ONBOARDING_ACTIONS.FETCHED_COMPANY_BACKGROUND : 
            return state
                .setIn(["companyBackground","status"] , STATE_STATUS.FETCHED)
                .setIn(["companyBackground", "data"] , new Map(payload.data['results'][0]));

        case ONBOARDING_ACTIONS.FAILED_FETCH_COMPANY_BACKGROUND:
            return state.setIn(["companyBackground", "status"] , STATE_STATUS.FETCH_FAILED);
        
        case ONBOARDING_ACTIONS.FETCH_DEVIATION_MATRIX:
            return state.setIn(["deviationMatrixReview","status"] , STATE_STATUS.FETCHING);

        case ONBOARDING_ACTIONS.FETCHED_DEVIATION_MATRIX : 
            return state
                .setIn(["deviationMatrixReview","status"] , STATE_STATUS.FETCHED)
                .setIn(["deviationMatrixReview", "data"] , new Map(payload.data));

        case ONBOARDING_ACTIONS.FAILED_FETCH_DEVIATION_MATRIX:
            return state.setIn(["deviationMatrixReview", "status"] , STATE_STATUS.FETCH_FAILED);
    
        case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
